export default __webpack_public_path__ + "static/media/opensea.6e9ba88a.svg";